import { render, staticRenderFns } from "./RankingRestaurantes.vue?vue&type=template&id=b1d83d96&scoped=true&lang=pug"
import script from "./RankingRestaurantes.vue?vue&type=script&lang=js"
export * from "./RankingRestaurantes.vue?vue&type=script&lang=js"
import style0 from "./RankingRestaurantes.vue?vue&type=style&index=0&id=b1d83d96&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b1d83d96",
  null
  
)

export default component.exports